import type { ApiAuthType } from '../../../apps/api-hono/src/routes/api_auth/_router'
import { hc } from 'hono/client'
import { getEnvVariable } from '@lib/utils/getEnvVariable';
import { getClientRequestOptions } from './getClientRequestOptions';


const client = hc<ApiAuthType>('')
type Client = typeof client

export const createAuthApiClient = (...args: Parameters<typeof hc>): Client => {
    return hc<ApiAuthType>(...args)
}
export const authApiClient = createAuthApiClient(
    `https://${getEnvVariable('PUBLIC_API_DOMAIN')}/auth/`,
    getClientRequestOptions()
)
